var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import GenericSchemeName from "@frameworks/shared-library/components/GenericSchemeName/GenericSchemeName";
import React, { useEffect, useState } from "react";
import newTag from "@frameworks/shared-library/assets/images/markets/newTag.svg";
import featuredTag from "@frameworks/shared-library/assets/images/markets/featuredTag.svg";
import Search from "@frameworks/shared-library/components/Search/search";
import { SearchAssetTypeEnum } from "@frameworks/shared-library/components/Search/constant";
/**
 * MFPlaceOrderSchemeNameColumn
 *
 * This component is used on Place order screen to display scheme name column
 *
 * @param {any} schemeDetails - scheme details
 * @param {string} transactionId - specific row's unique Id
 * @param {string} targetTransactionId - actioned row's transaction Id
 * @param {string[]} duplicatedOrders - information of duplicated orders on the screen - used to display duplicated tag
 * @param {Function} setShowSearchPopup - Function show or hide scheme search popup
 * @param {Function} setTransactionId - set current transaction Id
 * @param {boolean} showSearchPopup - show or hide scheme search popup
 * @param {Function} callbackSchemeSearchSelection - Call back function to set selected scheme details
 * @returns {}
 */
var MFPlaceOrderSchemeNameColumn = function (_a) {
    var schemeDetails = _a.schemeDetails, transactionId = _a.transactionId, targetTransactionId = _a.targetTransactionId, duplicatedOrders = _a.duplicatedOrders, setShowSearchPopup = _a.setShowSearchPopup, setTransactionId = _a.setTransactionId, showSearchPopup = _a.showSearchPopup, callbackSchemeSearchSelection = _a.callbackSchemeSearchSelection;
    var _b = __read(useState(false), 2), showDuplicateBlock = _b[0], setShowDuplicateBlock = _b[1]; // Controls block visibility
    useEffect(function () {
        if (duplicatedOrders.includes(transactionId)) {
            setShowDuplicateBlock(true); // Remove the entire block after 4 sec
        }
    }, [duplicatedOrders, transactionId]);
    return schemeDetails ? (React.createElement("div", { className: "d-flex flex-row place-order-scheme-name-column" },
        React.createElement(GenericSchemeName, { name: schemeDetails.schemeName, subText1: schemeDetails.catName, subText2: schemeDetails.subCatName, maxWidth: 235, transactionType: showDuplicateBlock && "Duplicate", parentClassName: "place-order-scheme-name", showTooltip: true, showImage: true, image: schemeDetails === null || schemeDetails === void 0 ? void 0 : schemeDetails.amcLogo, tooltipPlacement: "top-start" }),
        React.createElement("div", { className: "d-flex flex-column mt-lg-1 gap-2" },
            schemeDetails.isNew === "t" && (React.createElement("img", { className: "mgl-5 mgb-3", src: newTag, alt: "New Scheme" })),
            schemeDetails.isFeatured === "t" && (React.createElement("img", { className: "mgl-5 mgb-3", src: featuredTag, alt: "Featured Scheme" }))))) : (React.createElement("div", null,
        React.createElement("button", { className: "d-flex flex-row gap-2 pdl-15 pdr-15 pt-10 pb-10 add-product-btn align-items-center  bg_white", onClick: function () {
                setShowSearchPopup(true);
                setTransactionId(transactionId);
            } },
            React.createElement("i", { className: "edel-icon-plus-thin" }),
            React.createElement("span", { className: "DMSanN_15_400" }, "Add Product")),
        showSearchPopup && targetTransactionId === transactionId && (React.createElement(Search, { searchPopup: showSearchPopup, setSearchPopup: setShowSearchPopup, defaultActiveTab: SearchAssetTypeEnum.MF, setSearchData: function (data) {
                return callbackSchemeSearchSelection(data);
            }, hideTabs: true, placeOrder: true, placeholder: "Search for a fund", cachingAtMiddleWare: true }))));
};
export default MFPlaceOrderSchemeNameColumn;
